const APP_ID = 'g5b9ova4';

export function bootIntercom () {
  window.Intercom('update', {
    app_id: APP_ID
  });
}

export function bootIntercomForUser (user) {
  window.Intercom('update', {
    app_id: APP_ID,
    email: user.email
  });
}

export function hideIntercom () {
  window.Intercom('shutdown');
}



// WEBPACK FOOTER //
// ./src/services/intercom-service.js